import { ReactComponent as IconAdjustments } from "@/assets/svgs/icon-adjustments-horizontal.svg";
import Button from "@/components/Button/index";
import useModal from '@/hooks/use-modal/index'
import CardConfigure from '@/componentsDS/Modal/CardConfigure';
import Modal from '@/componentsDS/Modal/Modal';
import rem from '@/utils/rem'
import PropTypes from 'prop-types';
import { useState, useEffect } from "react";
import FilterRow from "../../../components/DataTable3/FilterRow/index";

const ETRFilterDropDown = ({
    resetFilter,
    filter,
    setFilter
}) => {

    const { visible: filterModal, show: showfilterModal, hide: hidefilterModal } = useModal();
    const [preFilter, setPreFilter] = useState(filter);

    const etrMakerCheckerStatusOptions = [
        { id: "DRAFT", label: "Draft", name: "Draft", $selected: false },
        { id: "ISSUING", label: "Issuing", name: "Issuing", $selected: false },
        { id: "ISSUED", label: "Issued", name: "Issued", $selected: false },
        { id: "ISSUANCE_FAILED", label: "Issuance Failed", name: "Issuance Failed", $selected: false },
        { id: "REVOKING", label: "Revoking", name: "Revoking", $selected: false },
        { id: "REVOKED", label: "Revoked", name: "Revoked", $selected: false },
        { id: "SURRENDERING", label: "Surrendering", name: "Surrendering", $selected: false },
        { id: "SURRENDERED", label: "Surrendered", name: "Surrendered", $selected: false },
        { id: "RESTORING", label: "Surrender Rejection In Progress", name: "Surrender Rejection In Progress", $selected: false },
        { id: "SHREDDING", label: "Shredding", name: "Shredding", $selected: false },
        { id: "SHREDDED", label: "Shredded", name: "Shredded", $selected: false },
        { id: "ISSUANCE_PENDING_APPROVAL", label: "Issuance Pending Approval", name: "Issuance Pending Approval", $selected: false },
        { id: "SURRENDER_PENDING_APPROVAL", label: "Surrender Pending Approval", name: "Surrender Pending Approval", $selected: false },
        { id: "RESTORE_PENDING_APPROVAL", label: "Surrender Rejection Pending Approval", name: "Surrender Rejection Pending Approval", $selected: false },
        { id: "SURRENDER_ACCEPTANCE_PENDING_APPROVAL", label: "Shredding Pending Approval", name: "Shredding Pending Approval", $selected: false },
        { id: "NOMINATION_PENDING_APPROVAL", label: "Nomination Pending Approval", name: "Nomination Pending Approval", $selected: false },
        { id: "NOMINATED", label: "Nominated", name: "Nominated", $selected: false },
        { id: "ENDORSEMENT_PENDING_APPROVAL", label: "Endorsement Pending Approval", name: "Endorsement Pending Approval", $selected: false },
        { id: "OWNER_TRANSFER_PENDING_APPROVAL", label: "Owner Transfer Pending Approval", name: "Owner Transfer Pending Approval", $selected: false },
        { id: "HOLDER_TRANSFER_PENDING_APPROVAL", label: "Holder Transfer Pending Approval", name: "Holder Transfer Pending Approval", $selected: false },
        { id: "OWNER_HOLDER_TRANSFER_PENDING_APPROVAL", label: "Owner Holder Transfer Pending Approval", name: "Owner Holder Transfer Pending Approval", $selected: false }
    ];

    const documentTypeOptions = [
        { id: "VERIFIABLE", label: "Verifiable Document", name: "Verifiable Document", $selected: false },
        { id: "TRANSFERABLE", label: "ETR", name: "ETR", $selected: false }
    ];

    const filterOptions = [
        {
            key: 'statusType',
            type: 'multiSelect',
            label: 'Status',
            placeHolderText: 'Select',
            options: etrMakerCheckerStatusOptions.map(s => ({ ...s, value: s.label.toUpperCase(), name: s.label })),
        },
        {
            key: 'documentType',
            type: 'multiSelect',
            label: 'Document Type',
            placeHolderText: 'Select',
            options: documentTypeOptions.map(s => ({ ...s, value: s.label.toUpperCase(), name: s.label })),
        },
        {
            key: 'date',
            type: 'dateRange',
            label: 'Date Period',
            placeHolderText: ['Start Date', 'End Date'],
        }
    ];

    useEffect(() => {
        setPreFilter(filter)
    }, [filter])

    return (<>
        <div data-testid="etr-icon-adjustments" onClick={showfilterModal} onKeyDown={showfilterModal} role='button'>
            <IconAdjustments />
        </div>
        <Modal visible={filterModal} variant="medium" close={hidefilterModal}>
            <CardConfigure style={{ maxWidth: rem(500), position: 'relative', top: rem(40) }}>
                <CardConfigure.Header>
					<CardConfigure.Header.Title>
						<div className="card-configure__header__left">
							<div className="card-configure__title">
								<div className="card-configure__title__left">
									<div className="etr-issuance-filter-group-title-icon"><IconAdjustments /></div>
								</div>
								<div className="card-configure__title__right">
									<div className="card-configure__title__right__top">
										Filter
									</div>
								</div>
							</div>
						</div>
					</CardConfigure.Header.Title>
                </CardConfigure.Header>
                <CardConfigure.Body>
                    <CardConfigure.Body.Col>
                        {filterOptions.map((filter) =>
                            <FilterRow
                                key={filter?.key}
                                filter={filter}
                                preFilter={preFilter}
                                setPreFilter={setPreFilter}
                            />
                        )}
                    </CardConfigure.Body.Col>
                </CardConfigure.Body>
                <CardConfigure.Footer>
                    <CardConfigure.Footer.Right>
                        <Button ghost round noborder nobackground noHover text="Reset" submit={() => {
                            setPreFilter(null)
                            resetFilter()
                            hidefilterModal()
                        }} />
                        <span style={{ width: rem(10), display: 'inline-block' }}></span>
                        <Button text="Apply"
                            round
                            submit={() => {
                                setFilter(preFilter)
                                hidefilterModal()
                            }}
                        />
                    </CardConfigure.Footer.Right>
                </CardConfigure.Footer>
            </CardConfigure>
        </Modal>
    </>
    );
};

ETRFilterDropDown.propTypes = {
    resetFilter: PropTypes.func,
    filter: PropTypes.object.isRequired,
    setFilter: PropTypes.func.isRequired
};

export default ETRFilterDropDown;
